<template>
<div class="chapter">
<div class="inner_page">
<a id="pv"></a>
<blockquote class="sink">
<p class="center "><em>To Michael Stearns,</em><br/>
<em>passager indeed</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?513323c7